var map = {
	"./bhagya gold & diamonds inauguration 01.jpg": 4992,
	"./bhagya gold & diamonds inauguration 02.jpg": 8607,
	"./event 01.jpg": 6621,
	"./event 02.jpg": 6722,
	"./event 03.jpg": 1007,
	"./event 04.jpg": 6692,
	"./event 04A.jpg": 7907,
	"./event 05.jpg": 4737,
	"./event 06.jpg": 5158,
	"./event 08.jpg": 184,
	"./event 09.jpg": 6197,
	"./event 10.jpg": 7567,
	"./event 11.jpg": 4898,
	"./event 13.jpg": 3232,
	"./event 14.jpg": 4883,
	"./event 15.jpg": 2710,
	"./event 16.jpg": 4129,
	"./event 17.jpg": 6756,
	"./event 18.jpg": 4231,
	"./event 19.jpg": 2074,
	"./event 20.jpg": 2058,
	"./fashion show winner 01.jpg": 4625,
	"./fashion show winner 02.jpg": 5014,
	"./fashion show winner 03.jpg": 275,
	"./sankarthil silks inauguration 01.jpg": 6322,
	"./sankarthil silks inauguration 02.jpg": 6221
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3878;